import Vue from 'vue'
import _ from 'lodash'

export const errorNotification = _.debounce((message) => {
  // eslint-disable-next-line
  console.log(message)
  Vue.swal.fire({ icon: 'error', timer: 0, showConfirmButton: true, title: 'Error: ' + message })
}, 2000, { leading: true, trailing: false })
